define('globalCtaHandler',[
    'mobileFormsCommon',
    'formValidator',
    'ajaxHelper',
    'i18n!nls/res',
    'routes',
    'vanillaMasker',
    'getPageToPush',
    'loadCtaResource',
    'domHelper',
],
  function (
    mobileFormsCommon,
    formValidator,
    ajaxHelper,
    language,
    routes,
    vanillaMasker,
    getPageToPush
  ) {
    'use strict';

    // Logic to support globals CTAs.
    (function () {
      let closeCtaGlobal;
      let overlayGlobal;
      let submitCtaGlobal;
      let modalInternationalCtaGlobal;
      let modalUserName;
      let modalUserMail;
      let modalInternational;
      let modalUserZipCtaGlobal;
      let modalUserPhone;
      let modalComments;
      let modalUserZip;
      let modalIncludeReco;
      let modalBasicFirstName;
      let modalBasicEmail;
      let modalBasicPhone;
      let modalBasicComment;
      let basicFormSubmitButton;
      let userFirstNameAndLastName = '';
      let userFirstName = '';
      let userLastName = '';
      let userEmail = '';
      let userZipCode = '';
      let userOutSideUs = '';
      let phone = '';
      let comments = '';
      let includeComms = '';
      let isBasic;
      let leadButtonEvent = '';

      /**
       * Adds the phone input mask for all phone inputs in the page.
       */
      const initPhoneMasks = function () {
        const phoneInputs = document.querySelectorAll('[name=phone i], [data-phone-input], [name="UserPhoneNumber"], [name="phone"]');

        phoneInputs.forEach(function (phoneInput) {
          vanillaMasker(phoneInput).maskPattern('(999) 999-9999');
        });
      }

      initPhoneMasks();

      let ctaGlobalContainer = document.getElementById('nhs_MoreInformationCtaHtml');
      let ctaBasicGlobalContainer = document.getElementById('nhs_BasicCtaHtml');
      let divBasicContactForm = document.getElementById('nhs_BasicContactForm');
      let moreInformationCtaGlobal = document.getElementById('nhs_MoreInformationCTAGlobal');
      let ctaGlobalForm; let
        basicContactForm;

      let fillValuesInputCta = function () {
        modalUserName.value = modalUserName.value ? modalUserName.value : userFirstNameAndLastName;
        modalUserMail.value = modalUserMail.value ? modalUserMail.value : userEmail;
        modalUserZipCtaGlobal.value = modalUserZipCtaGlobal.value ? modalUserZipCtaGlobal.value : userZipCode;
        modalInternationalCtaGlobal.checked = modalInternationalCtaGlobal.checked ? modalInternationalCtaGlobal.checked : userOutSideUs;
        if (modalInternationalCtaGlobal.checked) {
          modalUserZipCtaGlobal.value = '';
          userZipCode = '';
          modalUserZipCtaGlobal.disabled = true;
        } else {
          modalUserZipCtaGlobal.disabled = false;
        }
        modalUserPhone.value = modalUserPhone.value ? modalUserPhone.value : phone;
        modalComments.value = modalComments.value ? modalComments.value : comments;
        modalIncludeReco.checked = modalIncludeReco.checked ? modalIncludeReco.checked : includeComms;
      };

      let fillValuesInputBasic = function () {
        modalBasicFirstName.value = modalBasicFirstName.value ? modalBasicFirstName.value : userFirstName;
        modalBasicEmail.value = modalBasicEmail.value ? modalBasicEmail.value : userEmail;
        modalBasicPhone.value = modalBasicPhone.value ? modalBasicPhone.value : phone;
        modalBasicComment.value = modalBasicComment.value ? modalBasicComment.value : comments;
      };

      let closeModal = function (selectedObject) {
        selectedObject.removeAttribute('data-selected');
        moreInformationCtaGlobal.style.display = 'none';
        overlayGlobal.classList.remove('is-visible');
        document.body.removeClass('nhs_NoScrollComplete');
      };

      let clearModals = function (divContainerModal) {
        document.body.addEventListener('click', initForms);
        divContainerModal.innerHTML = '';
      };

      let handleBasicFormResponse = function (responseText1, responseText2) {
        let form = document.querySelector('#nhs_BasicContactForm form');
        let modalTitle = document.querySelector('#nhs_BasicContactForm .modal__title');
        let modalSubtitle = document.querySelector('#nhs_BasicContactForm .text--center');
        const closeButton = document.querySelector('[data-basic-close-button]');

        form.style.display = 'none';
        modalTitle.textContent = responseText1;
        modalSubtitle.textContent = responseText2;
        closeButton.dataset.ga4EventClick_target = 'Step 2';
      };

      let encodeObjectToUriString = function (object) {
        let uriString = Object.keys(object).map(function (key) {
          return key + '=' + object[key];
        }).join('&');

        return uriString;
      };

      let handleForms = function (userInfo) {
        let modal = document.getElementById('nhs_MoreInformationCTAGlobal');
        let closeModalButton = modal.querySelector('.modal__close.close-x-black');
        closeModalButton.click();

        require(['auth0ThankYouModal'],
          function (auth0ThankYouModal) {
            auth0ThankYouModal.show(userInfo);
          });
      };

      let logFormAnalyticsEvent = function (action, label) {
        let jsonForFormEvents;
        let inputForGaForms = document.getElementById('FormAbandonmentEvents');

        if (inputForGaForms && inputForGaForms.value !== '' && window.ga) {
          jsonForFormEvents = JSON.parse(inputForGaForms.value);
          ga('gtm2.send',
            'event',
            'Form Abandonment',
            JSON.parse(jsonForFormEvents[0])[action],
            JSON.parse(jsonForFormEvents[1])[label]);
        }
      };

      document.body.addEventListener('click', initForms);
      overlayGlobal = document.getElementById('nhs_OverlayPanelCTAGlobal');
      if (ctaGlobalContainer) {
        ctaGlobalForm = ctaGlobalContainer.innerHTML;
      }
      if (ctaBasicGlobalContainer) {
        basicContactForm = ctaBasicGlobalContainer.innerHTML;
      }

      /**
     * Used to gather all topics added via A/B test and add them to the data sent to the controller
     * @param {Object} data the form data
     * @param {Object} form the form used to get the topics
     */
      function addAbTestTopics(data, form) {
        const topicList = form.querySelectorAll('[data-ab-test-option]');

        topicList.forEach(function (topic) {
          data.set(topic.dataset.comment, topic.checked);
        });
      }

      /**
       * setSubmitButtonGA4Attributes: sets the required attributes for form calling GA4 event.
       * @param {object} config that contains the element to add the attributes and the name of thr
       * call to action button.
       */
      function setPhoneNumberButtonGA4Attributes(config){
        const { phoneButton, cta, isBasic, modalTarget } = config;
        const openModalButtonContainer = cta.parentElement;
        const buttonNameInput = openModalButtonContainer.querySelector('[name=ButtonName]');

        if (phoneButton) {
          phoneButton.dataset.event = 'true';
          phoneButton.dataset.ga4EventName = isBasic ? 'basic_phone_number_views' : 'phone_number_views';
          phoneButton.dataset.ga4EventButton_name = isBasic ? 'Call Now Button' : buttonNameInput.value;
          phoneButton.dataset.ga4EventClick_target = modalTarget;
          if (!isBasic) {
            phoneButton.dataset.ga4EventEvent_type = 'TDV Events';
            phoneButton.dataset.ga4EventCurrency = 'USD';
            phoneButton.dataset.ga4EventValue = '30';
          }
        }
      }

      /**
       * setCloseButtonGA4Attributes: sets the required attributes for form closing GA4 event.
       * @param {object} config that contains the element to add the attributes and the name of thr
       * call to action button.
       */
      function setCloseButtonGA4Attributes(config){
        const { isBasic, closeButton, cta } = config;
        const openModalButtonContainer = cta.parentElement;
        const buttonNameInput = openModalButtonContainer.querySelector('[name=ButtonName]')
        closeButton.dataset.event = 'true';
        closeButton.dataset.ga4EventName = `form_close${(isBasic ? '_basic' : '')}`;
        closeButton.dataset.ga4EventButton_name = buttonNameInput.value;
        closeButton.dataset.ga4EventClick_target = 'Step 1';
        closeButton.dataset.gaDimensionPriceReduction = '';
        closeButton.dataset.gaEventTracker = 'true';
        leadButtonEvent = buttonNameInput.value;
      }

      /**
       * setSubmitButtonGA4Attributes: sets the required attributes for form submission GA4 event.
       * @param {object} config that contains the element to add the attributes and the name of thr
       * call to action button.
       */
      function setSubmitButtonGA4Attributes(config){
        const { isBasic, submitButton, cta, modalTarget } = config;
        const openModalButtonContainer = cta.parentElement;
        const buttonNameInput = openModalButtonContainer.querySelector('[name=ButtonName]')
        submitButton.dataset.identity = 'true';
        submitButton.dataset.ga4IdentityEventName = isBasic ? 'basic_lead_submitted' : 'generate_lead';
        submitButton.dataset.ga4IdentityButton_name = buttonNameInput.value;
        submitButton.dataset.ga4IdentityClick_target = modalTarget;
        if (!isBasic) {
          submitButton.dataset.ga4IdentityEvent_type = 'TDV Events';
          submitButton.dataset.ga4IdentityCurrency = 'USD';
          submitButton.dataset.ga4IdentityValue = '30';
        }

        if (cta.dataset.priceReduction !== '') {
          submitButton.dataset.ga4IdentityPrice_reduction = cta.dataset.priceReduction;
        }
      }

      function getRecommendationConfigEvent(params) {
        const { leadButtonClicked } = params;
        return {
          ga4: {
            onClose: {
              eventType: 'GA4Event',
              eventName: 'form_close',
              params: {
                button_name: leadButtonClicked,
                click_target: 'Step 2'
              }
            },
            onUnCheckBox: {
              eventType: 'GA4Event',
              eventName: 'direct_rec_uncheck',
              params: {
                click_target: 'lead submission- discover comm',
              }
            },
            onSkip: {
              eventType: 'GA4Event',
              eventName: 'form_skip',
              params: {
                button_name: leadButtonClicked,
                click_target: 'lead submission- discover comm',
              }
            },
            onCloseThankYou: {
              eventType: 'GA4Event',
              eventName: 'form_close',
              params: {
                button_name: leadButtonClicked,
                click_target: 'Step 3'
              }
            }
          }
        }
      }

      function initForms(event) {
        window.NewHomeSource.Modules.tagManager.setDataLayerValue('loginEvents', {
          click_target: 'lead submission'
        });
        let element = event.target;
        let button = element.closest('button');
        const fromPage = document.querySelector('[data-from-page]');
        if (element.classList.contains('nhs_ContactBrochure')) {
          moreInformationCtaGlobal.innerHTML = ctaGlobalForm;
          isBasic = false;
        } else if (element.classList.contains('nhs_RequestInfo') || element.classList.contains('nhs_BasicHomesRequestInfo')) {
          divBasicContactForm.innerHTML = basicContactForm;
          isBasic = true;
          const leadsourcePage = button.dataset.leadSourcePage;

          if(fromPage && leadsourcePage){
            fromPage.value = leadsourcePage;
          }

        } else if (element.id === 'nhs_CloseModal' || element.id === 'nhs_ModalCloseCTAGlobal' || element.id === 'nhs_ModalCloseBasic') {
          overlayGlobal.classList.remove('is-visible');
          moreInformationCtaGlobal.setAttribute('style', 'display:none');
          divBasicContactForm.setAttribute('style', 'display:none');
          return;
        }

        basicFormSubmitButton = document.querySelector('.js_SubmitBasicForm');
        let closeBasicButton = document.getElementById('nhs_ModalCloseBasic');
        const phoneNumberCallButton = document.querySelector('[data-call-cta]');

        if (!isBasic) {
          closeCtaGlobal = document.getElementById('nhs_ModalCloseCTAGlobal');
          submitCtaGlobal = document.getElementById('nhs_ModalSubmitCTAGlobal');
          if (closeCtaGlobal && moreInformationCtaGlobal && overlayGlobal && submitCtaGlobal) {
            document.body.removeEventListener('click', initForms);
            modalInternationalCtaGlobal = document.getElementById('nhs_ModalLiveOutsideRegCTAGlobal');
            modalUserName = document.getElementById('nhs_ModalNameCTAGlobal');
            modalUserMail = document.getElementById('nhs_ModalEmailCTAGlobal');
            modalInternational = document.getElementById('nhs_ModalLiveOutsideRegCTAGlobal');
            modalUserZipCtaGlobal = document.getElementById('nhs_ModalZipCodeRegCTAGlobal');
            modalUserPhone = document.getElementById('nhs_ModalPhoneInputCTAGlobal');
            modalComments = document.getElementById('nhs_ModalCommentsCTAGlobal');
            modalUserZip = document.getElementById('nhs_ModalZipCodeRegCTAGlobal');
            modalIncludeReco = document.getElementById('nhs_ModalIncludeCommunitiesCTAGlobal');
            submitCtaGlobal.dataset.segmentEventButton_action = event.target.dataset.segmentEventButton_action;
            submitCtaGlobal.dataset.pandoraIdentityLabel = element.dataset.pandoraIdentityLabel || "0:";

            const modalTarget = element.dataset.modalTarget;
            if (modalTarget){
              const attrtiburesConfiguration = {
                cta: element,
                submitButton: submitCtaGlobal,
                closeButton: closeCtaGlobal,
                phoneButton: phoneNumberCallButton,
                isBasic: false,
                modalTarget
              };
              setSubmitButtonGA4Attributes(attrtiburesConfiguration);
              setCloseButtonGA4Attributes(attrtiburesConfiguration);
              setPhoneNumberButtonGA4Attributes(attrtiburesConfiguration);
            }

            const phoneInput = moreInformationCtaGlobal.querySelector('[name=phone]');
            vanillaMasker(phoneInput).maskPattern('(999) 999-9999');

            fillValuesInputCta();
            const page = getPageToPush.getNameToLog(location.href);
            const phoneCta = moreInformationCtaGlobal.querySelector("[data-cta-detail]");
            if (phoneCta) {
              phoneCta.dataset.ctaDetail = phoneCta.dataset.ctaDetail.replace('{{Page}}', page);
            }

            closeCtaGlobal.addEventToElement('click', function () {
              clearModals(moreInformationCtaGlobal);
              let selectedObject = document.querySelector('[data-listing-info][data-selected="true"]');
              let askQuestionButton = document.getElementById('nhs_AskBuilderAQuestion');
              logFormAnalyticsEvent('CLOSE', 'CONTACT');

              selectedObject.removeAttribute('data-selected');
              moreInformationCtaGlobal.style.display = 'none';
              overlayGlobal.removeClass('is-visible');
              document.body.removeClass('nhs_NoScrollComplete');

              if (askQuestionButton) {
                askQuestionButton.style.display = 'block';
              }
            });

            submitCtaGlobal.addEventToElement('click', function (event) {
              let selectedObject = document.querySelector('[data-listing-info][data-selected="true"]');
              let formElement = event.target.form;

              if (!selectedObject || !formValidator.validateForm(formElement)) {
                return;
              }

              let isCustomLocation = event.target.getAttribute('data-IsCustomLocation') === 'true';
              let isHome = selectedObject.getAttribute('is-home') === '1';
              let isMpc = selectedObject.getAttribute('is-mpc') === '1' ? 'true' : 'false';
              let commId = parseInt(selectedObject.getAttribute('comm-id')) || 0;
              let planId = parseInt(selectedObject.getAttribute('plan-id')) || 0;
              let specId = parseInt(selectedObject.getAttribute('spec-id')) || 0;
              let marketId = parseInt(selectedObject.getAttribute('market-id')) || 0;
              let builderId = parseInt(selectedObject.getAttribute('builder-id')) || 0;
              let builderName = selectedObject.getAttribute('builder-name');
              let isPlan = planId > 0 && specId <= 0;
              let isFreeBrochure = !isCustomLocation;
              let usesMatchMaker = document.getElementById('PartnerHasMatchMaker');
              let isCommDetail = isHome ? 'false' : 'true';
              let isComingSoon = parseInt(selectedObject.getAttribute('is-coming-soon')) > 0;
              let fromPage = selectedObject.dataset.fromPage || '';
              let generateLeadFrom = selectedObject.dataset.generateLeadFrom || '';
              let buttonNameSource = selectedObject.dataset.buttonNameSource || '';
              let leadAction = selectedObject.dataset.leadAction || '';
              let data = {};
              let leadType = isHome ? 'hm' : 'com';
              const inputLeadType = document.querySelector('[data-lead-type]');
              if (inputLeadType) {
                inputLeadType.value = leadType;
              }
              let comment = modalComments.value != '' ? 'Custom Home - ' + modalComments.value : 'Custom Home';

              if (isCustomLocation) {
                data = {
                  BuilderId: builderId,
                  Comments: comment,
                  CommunityId: commId,
                  Email: modalUserMail.value,
                  IsCustomLocation: true,
                  IsMobile: true,
                  IsPlan: isPlan,
                  FromPage: fromPage,
                  GenerateLeadFrom: generateLeadFrom,
                  ButtonNameSource: buttonNameSource,
                  LeadAction: leadAction,
                  LiveOutside: modalInternational.checked,
                  LivesOutside: modalInternational.checked,
                  MailAddress: modalUserMail.value,
                  MarketId: marketId,
                  Name: modalUserName.value,
                  Phone: modalUserPhone.value,
                  PlanId: planId,
                  SpecId: specId,
                  UserPostalCode: modalUserZip.value,
                  Zip: modalUserZip.value,
                  IgnoreComingSoonValidation: true
                };

                let customData = encodeObjectToUriString(data);
                let actionRequest = event.target.getAttribute('data-AskQuestionUrl');
                let askQuestionUrl = ajaxHelper.getAbsolutePathRequest(actionRequest + '/?' + customData);

                let xhr = new XMLHttpRequest();

                xhr.onreadystatechange = function () {
                  if (xhr.readyState === 4 && xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    data.UserExists = response.UserExists;
                    handleForms(data);
                  }
                };

                xhr.onerror = function (error) {
                  handleForms(data);
                };

                xhr.open('POST', askQuestionUrl);
                xhr.send();
              } else {
                data = {
                  BuilderId: builderId,
                  BuilderName: builderName,
                  Comments: modalComments.value,
                  CommunityId: commId,
                  CommunityList: commId,
                  Email: modalUserMail.value,
                  International: modalInternational.checked,
                  IsCustomLocation: false,
                  IsMPCommunity: isMpc,
                  IsPageCommDetail: isCommDetail,
                  IsPlan: isPlan,
                  FromPage: fromPage,
                  GenerateLeadFrom: generateLeadFrom,
                  ButtonNameSource: buttonNameSource,
                  LeadAction: leadAction,
                  IsComingSoon: isComingSoon,
                  LeadType: leadType,
                  LiveOutside: modalInternational.checked,
                  MailAddress: modalUserMail.value,
                  MarketId: marketId,
                  Name: modalUserName.value,
                  PartnerUsesMatchmaker: (usesMatchMaker.value === 'Y'),
                  Phone: modalUserPhone.value,
                  PlanId: planId,
                  SendAlerts: modalIncludeReco.checked,
                  SpecId: specId,
                  UserPhoneNumber: modalUserPhone.value,
                  UserPostalCode: modalUserZip.value,
                  Zip: modalUserZip.value,
                  IgnoreComingSoonValidation: !isComingSoon,
                  leadButtonClicked: event.target.dataset.segmentEventButton_action,
                };

                if (commId) {
                  data.id = commId;
                }

                if (planId && planId !== 0) {
                  data.id = planId;
                }

                if (specId && specId !== 0) {
                  data.id = specId;
                }

                if (isFreeBrochure) {
                  let cookieDate = new Date();
                  cookieDate.setTime(cookieDate.getTime() + (1 * 24 * 60 * 60 * 1000));

                  let expiresText = '; expires=' + cookieDate.toGMTString();
                  document.cookie = 'CTAName=Community - CTA Community Info' + expiresText + '; path=/; domain=newhomesource.com';

                  data.IsFreeBrochure = true;
                } else {
                  let leadAction = 'caaq';
                  data.LeadAction = leadAction;
                  data.IsFreeBrochure = false;
                  data.IsAskQuestion = leadAction === 'caaq';

                  if (leadAction === 'caaq') {
                    let date = new Date();
                    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
                    let expires = '; expires=' + date.toGMTString();
                    document.cookie = 'CTAName=Ask the Builder a Question' + expires + '; path=/; domain=newhomesource.com';
                  }
                }

                require(['recommendedCommunities'], function (recommendations) {
                  let callActionsAfterRecommended = function (sendAlerts) {
                    mobileFormsCommon.executeActionsAfterRequestRecommended(sendAlerts);
                    clearModals(moreInformationCtaGlobal);
                  };

                  let fallbackFunction = function () {
                    clearModals(moreInformationCtaGlobal);
                    closeModalBtn.click();
                  };

                  let initCallback = function () {
                    closeModal(selectedObject);
                    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
                      detail: {
                        data: {
                          eventType: "GAEvent",
                          price_reduction: '',
                        }
                      }
                    }));
                  };

                  const options = {
                    userData: data,
                    fallbackCallback: fallbackFunction,
                    successCallback: callActionsAfterRecommended.bind(this, data.SendAlerts),
                    element: selectedObject,
                    events: getRecommendationConfigEvent({
                      leadButtonClicked: leadButtonEvent
                    })
                  }

                  recommendations.calculateRecommendations(options);
                  recommendations.init(data, initCallback);
                });
              }
            });

            modalInternationalCtaGlobal.addEventToElement('change', function () {
              modalUserZipCtaGlobal.value = '';
              modalUserZipCtaGlobal.disabled = modalInternationalCtaGlobal.checked;
            });
          }
        } else if (closeBasicButton && basicFormSubmitButton) {
          document.body.removeEventListener('click', initForms);
          modalBasicFirstName = document.getElementById('b1534866178726');
          modalBasicEmail = document.getElementById('b1534872487746');
          modalBasicPhone = document.getElementById('b1534872504388');
          modalBasicComment = document.getElementById('b1534872527220');
          const attributes = ['eventCode', 'builder', 'community', 'parentCommunityId',
            'market', 'basicListingId', 'planId', 'specId', 'submittedEvent', 'basic', 'button_action',
            'segmentIdentity', 'segmentIdentityEvent', 'submittedRecipient', 'pandoraIdentityLabel', 'isBasicListing',
            'card_id', 'builderName', 'segmentEventButton_action'];

          for (let index = 0; index < attributes.length; index += 1) {
            const attribute = attributes[index];
            if (element.dataset[attribute]) {
              basicFormSubmitButton.dataset[attribute] = element.dataset[attribute];
            }
          }

          const modalTarget = element.dataset.modalTarget;
          if(modalTarget){
            const attrtiburesConfiguration = {
              cta: element,
              submitButton: basicFormSubmitButton,
              closeButton: closeBasicButton,
              phoneButton: phoneNumberCallButton,
              isBasic: true,
              modalTarget
            };
            setCloseButtonGA4Attributes(attrtiburesConfiguration);
            setSubmitButtonGA4Attributes(attrtiburesConfiguration);
            setPhoneNumberButtonGA4Attributes(attrtiburesConfiguration);
          }

          closeBasicButton.addEventToElement('click', function () {
            clearModals(divBasicContactForm);
            document.body.removeClass('nhs_NoScrollComplete');
          });
          fillValuesInputBasic();
          const phoneInput = divBasicContactForm.querySelector('[name=UserPhoneNumber]');
          vanillaMasker(phoneInput).maskPattern('(999) 999-9999');
          modalBasicPhone.dispatchEvent(new Event('keyup'));
          basicFormSubmitButton.addEventToElement('click', function (event) {
            const leadType = document.querySelector('#LeadType');
            const inputLeadType = document.querySelector('[data-lead-type]');
            if (inputLeadType && leadType) {
              inputLeadType.value = leadType.value;
            }
            let basicForm = document.querySelector('#nhs_BasicContactForm form');

            if (formValidator.validateForm(basicForm)) {
              let data = new FormData(basicForm);
              const fromPage = document.querySelector('[data-from-page]');

              // if the from page hasn't been set in the form, set it to the value of the data-from-page attribute
              if(!data.has('FromPage') && fromPage && fromPage.value){
                data.set('FromPage', fromPage.value);
              }

              let xhr = new XMLHttpRequest();

              xhr.onload = function () {
                handleBasicFormResponse(language.thankYou, language.anAgentWillBeInContact);
                document.body.dispatchEvent(new CustomEvent("sendLeadSubmittedSegmentEvent",
                  { detail: { targetEvent: event, formData: data } }));
              };

              xhr.onerror = function () {
                handleBasicFormResponse(language.aSiteErrorHasOccurred, language.pleaseTryAgainLater);
              };

              addAbTestTopics(data, basicForm);

              xhr.open('POST', basicForm.action);
              xhr.withCredentials = true;
              xhr.send(data);
            }
          });
        }
        if (!window.Mailcheck) {
          require(['emailDomainValidator']);
        } else {
          window.NewHomeSource.EmailDomainValidator();
        }

        initPhoneMasks();
      }

      moreInformationCtaGlobal.addEventToElement('change', function (event) {
        let element = event.target;
        switch (element.id) {
          case 'nhs_ModalNameCTAGlobal':
            userFirstNameAndLastName = element.value;
            break;
          case 'nhs_ModalEmailCTAGlobal':
            userEmail = element.value;
            break;
          case 'nhs_ModalZipCodeRegCTAGlobal':
            userZipCode = element.value;
            break;
          case 'nhs_ModalLiveOutsideRegCTAGlobal':
            userOutSideUs = element.checked;
            break;
          case 'nhs_ModalPhoneInputCTAGlobal':
            phone = element.value;
            break;
          case 'nhs_ModalCommentsCTAGlobal':
            comments = element.value;
            break;
          case 'nhs_ModalIncludeCommunitiesCTAGlobal':
            includeComms = modalIncludeReco.checked;
            break;
        }
      });

      divBasicContactForm.addEventToElement('change', function (event) {
        let element = event.target;
        switch (element.id) {
          case 'b1534866178726':
            userFirstName = element.value;
            break;
          case 'b1534872438574':
            userLastName = element.value;
            break;
          case 'b1534872487746':
            userEmail = element.value;
            break;
          case 'b1534872504388':
            phone = element.value;
            break;
          case 'b1534872527220':
            comments = element.value;
            break;
        }
      });
    }());

    let fillGlobalCtasWithUserInformation = function (isFreeBrochure, isComingSoon, isCustomLocation) {
      let userName = document.getElementById('UserProfileName');
      let userMail = document.getElementById('UserMail');
      let userZip = document.getElementById('UserZipCode');
      let userPhone = document.getElementById('UserPhone');
      let modalUserName = document.getElementById('nhs_ModalNameCTAGlobal');
      let modalUserMail = document.getElementById('nhs_ModalEmailCTAGlobal');
      let modalUserZip = document.getElementById('nhs_ModalZipCodeRegCTAGlobal');
      let modalInternational = document.getElementById('nhs_ModalLiveOutsideRegCTAGlobal');
      let modalUserPhone = document.getElementById('nhs_ModalPhoneInputCTAGlobal');
      let modalTitle = document.getElementById('nhs_ModalTitleCTAGlobal');
      let modalSubmit = document.getElementById('nhs_ModalSubmitCTAGlobal');
      let includeCommSimilarHomes = document.getElementById('nhs_ModalIncludeCommunitiesCTAGlobal');
      let privacyPolicySection = document.getElementById('nhs_privacyPolicy');

      let showPrivacyPolicyFromCta = function () {
        if (privacyPolicySection) {
          privacyPolicySection.style.display = null;
          privacyPolicySection.style.visibility = 'visible';
          privacyPolicySection.parentNode.classList.add('first');
        }
      };

      if (includeCommSimilarHomes instanceof HTMLInputElement) {
        includeCommSimilarHomes.checked = (document.getElementById('PartnerHasMatchMaker').value === 'Y') && (document.getElementById('MatchMakerFlagOptedIn').value === 'False');
      }

      if (userZip) {
        if (userZip.value === '') {
          modalInternational.checked = true;
          modalUserZip.disabled = true;
        } else {
          modalInternational.value = userZip.value;
        }
      }

      if (userName) {
        modalUserName.value = userName.value;
      }

      if (userMail) {
        modalUserMail.value = userMail.value;
      }

      if (userZip) {
        modalUserZip.value = userZip.value.trim();
      }

      if (userPhone) {
        modalUserPhone.value = userPhone.value;
      }

      if (isFreeBrochure && !isComingSoon) {
        modalTitle.innerHTML = language.getYourFreeBrochure + '!';
        modalSubmit.value = language.getFreeBrochures.substring(0, language.getFreeBrochures.length - 1);
        showPrivacyPolicyFromCta();
      } else if (isCustomLocation) {
        modalTitle.innerHTML = language.askAQuestion;
        modalSubmit.value = language.askQuestion;
      } else {
        modalTitle.innerHTML = language.getMoreInformation;
        modalSubmit.value = language.sendMessageToBuilder;
      }
    };

    let onClickRequestInfo = function (event) {
      let itemInfo = event.target.closest('[data-listing-info]') || document.querySelector('[data-listing-info]');
      let basicForm = document.getElementById('nhs_BasicContactForm');
      let modalSubtitle = basicForm.querySelector('.text--center');

      modalSubtitle.textContent = itemInfo.querySelector("[name='PropertyName']").value;
      basicForm.style.display = 'block';
      basicForm.querySelector('form').style.display = 'block';
      basicForm.querySelector('form').action = itemInfo.getAttribute("data-basicleadsubmissionurl");
      basicForm.querySelector("[name='BuilderName']").value = itemInfo.querySelector("[name='BuilderName']").value;
      basicForm.querySelector("[name='BuilderId']").value = itemInfo.querySelector("[name='BuilderId']").value;
      basicForm.querySelector("[name='PropertyDescription']").value = itemInfo.querySelector("[name='PropertyName']").value;
      basicForm.querySelector("[name='PropertyAddress']").value = itemInfo.querySelector("[name='PropertyAddress']").value;
      basicForm.querySelector("[name='ZipCode']").value = itemInfo.querySelector("[name='ZipCode']").value;
      basicForm.querySelector("[name='MarketId']").value = itemInfo.querySelector("[name='MarketId']").value;
      basicForm.querySelector("[name='IsResultPage']").value = itemInfo.querySelector("[name='IsResultPage']").value;
      basicForm.querySelector('a[data-id=BasicListingProviderPhone]').href = itemInfo.querySelector('#nhs_ContactPhone').value;
      basicForm.querySelector("[name='Function']").value = itemInfo.querySelector("[name='Function']").value;
      basicForm.querySelector("[name='ListingId']").value = itemInfo.querySelector("[name='ListingId']") !== null ? itemInfo.querySelector("[name='ListingId']").value : null;
      basicForm.querySelector("[name='CommunityId']").value = itemInfo.querySelector("[data-community]") ? itemInfo.querySelector("[data-community]").dataset.community : '';
      basicForm.querySelector("[name='PlanId']").value = itemInfo.querySelector("[data-plan-id]") ? itemInfo.querySelector("[data-plan-id]").dataset.planId : '';
      basicForm.querySelector("[name='SpecId']").value = itemInfo.querySelector("[data-spec-id]") ? itemInfo.querySelector("[data-spec-id]").dataset.specId : '';
      document.getElementsByTagName('BODY')[0].addClass('nhs_NoScrollComplete');
    };

    function linksHandler(event) {
      let elm = event.target || event.srcElement;
      let overlayGlobal = document.getElementById('nhs_OverlayPanelCTAGlobal');

      if (elm.type === 'checkbox' && event.type !== 'click') {
        return;
      }

      /**
       * SRP, and comm details
       */
      if ((elm.tagName === 'A' || elm.tagName === 'BUTTON') && elm.hasClass('nhs_ContactBrochure')) {
        let brochureObject = elm.closest('[data-listing-info]');
        let modalBrochure = document.getElementById('nhs_MoreInformationCTAGlobal');
        let brochurePropertyName = document.getElementById('nhs_PropertyNameCTAGlobal');
        let listingId = document.getElementById('ListingId');
        let phoneBrochure = document.getElementById('nhs_ModalPhoneCta');
        let recommendationsCheckSection = document.getElementById('nhs_ModalIncludeCommunitiesCTAGlobal').parentElement;

        if (!brochureObject && modalBrochure) {
          return false;
        }

        let isComingSoon = parseInt(brochureObject.getAttribute('is-coming-soon')) > 0;
        let isCustomLocation = elm.getAttribute('data-IsCustomLocation') === 'true';
        let askQuestionUrl = elm.getAttribute('data-AskQuestionUrl');
        let submitFormButton = modalBrochure.querySelector('[data-submit]');

        if (isCustomLocation) {
          recommendationsCheckSection.style.display = 'none';
          fillGlobalCtasWithUserInformation(false, isComingSoon, isCustomLocation);
          submitFormButton.setAttribute('data-IsCustomLocation', true);
          submitFormButton.setAttribute('data-AskQuestionUrl', askQuestionUrl);
        } else {
          recommendationsCheckSection.style.display = 'block';
          fillGlobalCtasWithUserInformation(true, isComingSoon, isCustomLocation);
          submitFormButton.setAttribute('data-IsCustomLocation', false);
          submitFormButton.removeAttribute('data-AskQuestionUrl');
        }

        brochurePropertyName.innerText = brochureObject.getAttribute('listing-name') + ' ' + language.by + ' ' + brochureObject.getAttribute('builder-name');
        listingId.value = brochureObject.getAttribute('comm-id');
        brochureObject.setAttribute('is-free-brochure', 'true');
        brochureObject.setAttribute('data-selected', 'true');
        if (phoneBrochure) {
          phoneBrochure.setAttribute('href', 'tel:' + brochureObject.getAttribute('data-phone'));
        }
        if(overlayGlobal){
          overlayGlobal.addClass('is-visible');
        }
        modalBrochure.show();
        modalBrochure.querySelector('form').style.display = 'block';
        modalBrochure.querySelector('[name=phone]').dispatchEvent(new Event('keyup'));

        document.getElementsByTagName('BODY')[0].addClass('nhs_NoScrollComplete');
      }

      /**
       * SRP and About page BSP
       */
      if (elm.hasClass('nhs_RequestInfo') || elm.dataset.basicLearnMore !== undefined) {
        onClickRequestInfo(event);
        overlayGlobal.addClass('is-visible');
      }
    }

    document.addEventToElement('click', linksHandler, false);
    document.addEventToElement('change', linksHandler, false);
  }
);

